const projects = [
	{
		name: "everyBuddy",
		subtitle: "React Native App",
		repo: "https://github.com/everybuddy-lacapsule/everybuddy",
		tech: [
			"Node.js",
			"React Native",
			"React Native Elements",
			"React Navigation",
			"Expo",
			"Expo Location",
			"Dotenv",
			"Mongoose",
			"Express",
			"Google maps API",
			"Socket.io",
			"bCrypt",
			"Uniqid",
			"Express file upload",
			"Node geocoder",
			"Cloudinary",
			"Axios",
		],
		languages: ["JSX", "CSS", "JavaScript"],
		preview: (
			<iframe
				width="100%"
				height="400px"
				src="https://www.youtube.com/embed/MM9L4YD0ARs"
				title="YouTube video player"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		),
		description:
			"Professional team project built from scratch, exclusive social network for schools' former students including instant messages, interactive map with active search and filters, profile creation and edition, secured authentication, friendlist system handling, NoSQL database.",
	},
	{
		name: "Morning News",
		subtitle: "React App",
		repo: "https://github.com/xmelinand/Morning-News",
		preview: (
			<iframe
				width="100%"
				height="400px"
				src="https://www.youtube.com/embed/8QGkb_DUdl4"
				title="YouTube video player"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		),
		tech: [
			"Node.js",
			"React",
			"Mongoose",
			"bCrypt",
			"antDesign",
			"Express",
			"API",
		],
		languages: ["JSX", "CSS", "JavaScript"],
		description:
			"Training react project, including news API loading and displaying content, wish list systems and secured authentication with NoSQL database.",
	},
	{
		name: "Locapic",
		subtitle: "React Native App",
		repo: "https://github.com/xmelinand/Locapic",
		preview: (
			<iframe
				width="100%"
				height="400px"
				src="https://www.youtube.com/embed/cnfnslR5jyc"
				title="YouTube video player"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		),
		tech: [
			"Node.js",
			"React Native",
			"Expo",
			"Google maps API",
			"MongoDB",
			"Express",
			"React Native Elements",
			"Websockets.io",
			"Local Storage",
		],
		languages: ["JSX", "CSS", "JavaScript"],
		description:
			"First mobile project using expo and Google maps API, authentication, session management using local storage.  ",
	},
	// {
	// 	name: "FaceUp",
	// 	subtitle: "React Native App",
	// 	repo: "",
	// 	preview: "../logo192",
	// 	tech: [
	// 		"Node.js",
	// 		"React Native",
	// 		"Expo",
	// 		"Facial Recognition API",
	// 		"MongoDB",
	// 		"Cloudinary",
	// 		"React Native Elements",
	// 		"Express",
	// 	],
	// 	languages: ["JSX", "CSS", "JavaScript"],
	// 	description:
	// 		"Mobile app using a facial recognition API through native use of the device's camera and temp files upload to cloudinary.",
	// },
	{
		name: "Mymoviz",
		subtitle: "React App",
		repo: "https://github.com/xmelinand/mymovies",
		preview: (
			<iframe
				width="100%"
				height="400px"
				src="https://www.youtube.com/embed/zQ0r0STC_X4"
				title="YouTube video player"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		),
		tech: ["Node.js", "React", "MongoDB", "ReactStrap", "Express", "API"],
		languages: ["JSX", "CSS", "JavaScript"],
		description:
			"Single page app displaying the latest trending movies through 'My Movie DB' API with a wishlist, rating & liking interactions.",
	},
	{
		name: "Ticketac",
		subtitle: "Express responsive website",
		repo: "https://github.com/xmelinand/mymovies",
		preview: (
			<iframe
				width="100%"
				height="400"
				src="https://www.youtube.com/embed/oVz9McqWkXw"
				title="YouTube video player"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		),
		tech: [
			"Node.js",
			"Express",
			"Express Session",
			"Bootstrap",
			"Mongoose",
			"EJS",
		],
		languages: ["HTML", "CSS", "JavaScript"],
		description: <p>2 days sprint collaboration w/  
        <a href='https://ban-works.github.io'> Ban-Works</a> <br/>
        Train reservation website, express backend with use of mongoDB to store bookable journeys, working searchbar, error management, safe authentication, user history.</p>,
	},
	{
		name: "BikeShop",
		subtitle: "Express website",
		repo: "https://github.com/xmelinand/mymovies",
		preview: (
			<iframe
				width="100%"
				height="400"
				src="https://www.youtube.com/embed/5o4gN_9bNKo"
				title="YouTube video player"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		),
		tech: ["Node.js", "Express", "Express Session", "Stripe", "EJS"],
		languages: ["HTML", "CSS", "JavaScript"],
		description: "Merchant Website using Stripe for payments, Express backend.",
	},
];

export default projects;
